import { useCallback, useRef } from "react"

/** Calls `onSettled` from a load's success or error path without retriggering that load. */
export function useInitialLoadReporter(onSettled: (() => void) | undefined) {
  const onSettledRef = useRef(onSettled)
  onSettledRef.current = onSettled
  return useCallback(() => {
    onSettledRef.current?.()
  }, [])
}
